import React, { useEffect, useState } from "react"
import { Container, Row, Col, Input } from "reactstrap"
import PageMetaTags from "components/PageMetaTags"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import TableComponent from "components/Table"
import { connect } from "react-redux"
import { getSiteUsers } from "store/actions"
import siteUsersListColumns from "./siteUsersListColumns"
import { SaveButton } from "components/Buttons"
import { withRouter } from "react-router-dom"

const PAGE_TITLE = "Platform Users"

const SiteUsers = ({ getSiteUsers, siteUsers, loading, vendors, history }) => {
  const [defaultOrder, setDefaultOrder] = useState({
    o: "last_access",
    od: "desc",
  })
  const [searchValue, setSearchValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)

  useEffect(() => {
    getSiteUsers({
      include_admins: false,
      m: 10,
      o: "last_access",
      od: "desc",
      page: 1,
      s: "",
    })
  }, [])

  const actions = [
    {
      name: "Edit",
      onClick: item => {
        history.push({
          pathname: `/profile/${item.id}`,
          state: { displayExp: true },
        })
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
  ]

  const handlePageChange = page => {
    getSiteUsers({
      include_admins: false,
      m: 10,
      ...defaultOrder,
      page: page,
      ...(searchValue?.trim()?.length ? { s: searchValue } : {}),
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getSiteUsers({
      include_admins: false,
      m: 10,
      o: sortField,
      od: sortOrder,
      page: 1,
      ...(searchValue?.trim()?.length ? { s: searchValue } : {}),
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  const handleSearch = () => {
    if (searchValue?.trim()?.length) {
      setShowResetButton(true)
      getSiteUsers({
        include_admins: false,
        m: 10,
        ...defaultOrder,
        page: 1,
        s: searchValue,
      })
    }
  }

  const handleResetSearch = () => {
    setShowResetButton(false)
    setSearchValue("")
    getSiteUsers({
      include_admins: false,
      m: 10,
      ...defaultOrder,
      page: 1,
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title={PAGE_TITLE} />
        <Container fluid>
          <Row>
            <Col className="mt-2">
              <BreadcrumbTitle
                title={PAGE_TITLE}
                breadcrumbItems={[
                  { title: "Dashboard" },
                  { title: PAGE_TITLE },
                ]}
              />
            </Col>
          </Row>
          <Row className="d-flex justify-content-center">
            <Col xs="auto">
              <Input
                value={searchValue}
                onChange={event => {
                  setSearchValue(event.target.value)
                }}
                placeholder="Search"
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                content="Search"
                type="button"
                onClick={handleSearch}
              />
            </Col>
            {showResetButton && (
              <Col xs="auto">
                <SaveButton
                  content="Reset"
                  color="light"
                  type="button"
                  onClick={handleResetSearch}
                />
              </Col>
            )}
          </Row>
          <Row className="my-3">
            <Col>
              <TableComponent
                columns={siteUsersListColumns()}
                data={
                  siteUsers
                    ? siteUsers?.data?.map(user => ({
                        ...user,
                        vendor: vendors?.find(
                          vendor => vendor?.id === user?.vendor_id
                        )?.name,
                      }))
                    : []
                }
                loadingData={loading}
                paginationData={{
                  current_page: siteUsers?.current_page,
                  last_page: siteUsers?.last_page,
                  total_items: siteUsers?.total,
                  items_per_page: siteUsers?.per_page,
                  from: siteUsers?.from,
                  to: siteUsers?.to,
                  first_page: 1,
                }}
                actions={actions}
                onPageChange={handlePageChange}
                onTableSort={handleSort}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = state => ({
  siteUsers: state.SiteUsers.siteUsers,
  loading: state.SiteUsers.loading,
  vendors: state.clients.vendorsList,
})

const mapDispatchToProps = dispatch => ({
  getSiteUsers: values => dispatch(getSiteUsers(values)),
})

export default withRouter(
  connect(mapStatetoProps, mapDispatchToProps)(SiteUsers)
)
